//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'dataDetail',
  data () {
    return {
      cycleType: 1,
      actvCountSort: 2,
      joinPeopleSort: 2,
      nameSort: 0,
      list: []
    }
  },
  created () {
    this.getlist(1)
  },
  methods: {
    onActvSort () {
      this.actvCountSort === 1 ? this.actvCountSort = 0 : this.actvCountSort = 1
      this.nameSort = 0
      this.joinPeopleSort = 2
      this.testList = this.sortByKey(this.list, 'activeTotal', this.actvCountSort)
    },
    onJoinSort () {
      this.joinPeopleSort === 1 ? this.joinPeopleSort = 0 : this.joinPeopleSort = 1
      this.nameSort = 0
      this.actvCountSort = 2
      this.testList = this.sortByKey(this.list, 'joinTotal', this.joinPeopleSort)
    },
    onNameSort () {
      this.showLoading()
      this.joinPeopleSort = 2
      this.actvCountSort = 2
      this.nameSort = 1
      this.list.sort(function (a, b) {
        var nameA = a.collegename.toUpperCase()
        var nameB = b.collegename.toUpperCase()
        return ((nameA < nameB) ? -1 : ((nameA > nameB) ? 1 : 0))
      })
    },
    getlist (type) {
      this.cycleType = type
      this.actvCountSort = 2
      this.joinPeopleSort = 2
      this.nameSort = 0
      var params = new URLSearchParams()
      params.append('schoolid', this.getCookie('schoolid'))
      params.append('type', type)
      this.$http({
        method: 'post',
        url: '/report/allCollegeActivityList',
        params: params
      }).then(res => {
        this.list = res.result
      }).catch(error => {
        console.log(error)
      })
    },
    sortByKey (array, key, type) {
      this.showLoading()
      return array.sort(function (a, b) {
        a[key] = a[key] == null ? 0 : a[key]
        b[key] = b[key] == null ? 0 : b[key]
        var x = parseInt(a[key])
        var y = parseInt(b[key])
        if (type === 1) {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        } else {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0))
        }
      })
    },
    showLoading () {
      this.$vux.loading.show({text: ''})
      setTimeout(() => {
        this.$vux.loading.hide()
      }, 200)
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/dataDetail/dataDetail.vue